<template>
    <div style="padding: 16px 16px;    height: calc(100vh - 100px);
    background-color: #080718ff;
    overflow-y: scroll;
    padding-bottom: 30px;color: #fff" >
        <div class="w-full flex items-center justify-center">
            <div class="btn1" :style="{'color':menuSelect === 1 ? '#000000ff' : '','background': menuSelect === 1 ? '#ffc000' : ''}" @click="selelctMenu(1)">{{langObj['列表显示']}}</div>
            <div class="btn1" :style="{'color':menuSelect === 2 ? '#000000ff' : '#ffffff','background': menuSelect === 2 ? '#ffc000' : ''}" @click="selelctMenu(2)">{{langObj['台账显示']}}</div>
        </div>

        <div class="mt-4 w-full">
           <listComponent v-if="menuSelect === 1"></listComponent> 
           <infoComponent v-if="menuSelect === 2"></infoComponent> 
        </div>
    
    </div>
</template>

<script lang="ts" setup>
import { defineComponent, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
// import request from "../../common/request";
import { v4 as uuidv4 } from "uuid";
import listComponent from "./list.vue";
import infoComponent from "./info.vue";
import { langList } from "../../common/lang";
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";

let langObj: any = ref({})
let language: any = ref('English')
const getLang = () => {
     language.value = 'English'
    langObj.value = langList[language.value]
}
 getLang()


let menuSelect = ref(1)     //1: 列表显示  2:台账显示

const selelctMenu = (ev:any) => {
    menuSelect.value = ev
}

</script>


<style lang="less" scoped>

.btn1 {
    padding: 3px 10px;
    border-radius: 2px;
    border: 1px solid #171325ff;
    cursor: pointer;
}

</style>
